import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import PlantExplorer from "../pages/PlantExplorer";
import PlantExplorerSearch from "../pages/PlantExplorer/PlantExplorerSearch";
import AboutUs from "../pages/AboutUs";
import Products from "../pages/Products";
import ProductDetails from "../pages/ProductDetails";
import Cart from "../pages/Cart";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Account from "../pages/Account";
import ValidateOtp from "../pages/Register/components/ValidateOtp";
import ForgotPassword from "../pages/Login/components/ForgotPassword";
import OrderHistory from "../pages/OrderHistory";
import OrderHistoryDetail from "../pages/OrderHistory/OrderHistoryDetail";
import ListNotification from "../pages/ListNotification";
import ProductCard from "../pages/Products/components/ProductCard";
import Pages from "../pages";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/plants-explorer/search" element={<PlantExplorerSearch />} />
      <Route path="/plants-explorer" element={<PlantExplorer />} />
      <Route path="/products-plants" element={<Products />} />
      <Route path="/products-pots" element={<Products />} />
      <Route
        path="/search"
        element={
          <Pages>
            <ProductCard />
          </Pages>
        }
      />
      <Route path="/product-details/:id" element={<ProductDetails />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/account" element={<Account />} />
      <Route path="/validateOtp" element={<ValidateOtp />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/order-history" element={<OrderHistory />} />
      <Route path="/order-detail" element={<OrderHistoryDetail />} />
      <Route path="/notifications" element={<ListNotification />} />
    </Routes>
  );
}
